import { Variants } from "framer-motion";

export const containerVariants: Variants = {
	hidden: { /* opacity: 0 */ },
	visible: {
		/* opacity: 1, */
		transition: {
			staggerChildren: 0.2, // Delay among each card
			delayChildren: 0.2, // Initial delay
		},
	},
};